export default __webpack_public_path__ + "static/media/notification.3b3e0c6e.mp3";